var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialVk28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.495 8.702c.153-.479 0-.83-.728-.83H21.36c-.611 0-.894.303-1.047.638 0 0-1.223 2.799-2.957 4.617-.561.526-.816.693-1.122.693-.153 0-.375-.167-.375-.645V8.702c0-.574-.177-.83-.687-.83h-3.783c-.382 0-.612.266-.612.519 0 .544.867.67.956 2.2v3.325c0 .73-.14.861-.446.861-.816 0-2.8-2.81-3.978-6.027-.23-.626-.462-.878-1.077-.878H3.825c-.687 0-.825.303-.825.638 0 .598.816 3.564 3.8 7.487 1.988 2.679 4.79 4.131 7.34 4.131 1.53 0 1.72-.322 1.72-.878v-2.025c0-.645.144-.774.629-.774.357 0 .969.168 2.396 1.46 1.632 1.53 1.901 2.217 2.82 2.217h2.406c.688 0 1.032-.322.833-.959-.217-.634-.996-1.555-2.03-2.646-.56-.622-1.402-1.291-1.657-1.626-.357-.43-.255-.622 0-1.005 0 0 2.932-3.875 3.238-5.19Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialVk28);
export default __webpack_public_path__ + "static/media/social-vk_28.d473cca4.svg";
export { ForwardRef as ReactComponent };